module.exports = __webpack_public_path__ + "static/media/AirbnbCerealApp-Bold.d163b0d0.woff2";